type JsonAny = any;

function baseUrl() {
  const raw = String(process.env.REACT_APP_WORKER_URL || "").trim();
  if (!raw) throw new Error("REACT_APP_WORKER_URL fehlt");
  return raw.replace(/\/+$/, "");
}

async function readBody(res: Response) {
  const t = await res.text();
  try {
    return t ? JSON.parse(t) : null;
  } catch {
    return t;
  }
}

export async function workerGetModels(adminKey: string, refresh: boolean): Promise<JsonAny> {
  const url = `${baseUrl()}/admin/models?refresh=${refresh ? "1" : "0"}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${adminKey}`
    }
  });

  const body = await readBody(res);
  if (!res.ok) {
    const msg = typeof body === "string" ? body : JSON.stringify(body);
    throw new Error(msg || `HTTP ${res.status}`);
  }
  return body;
}

export async function workerImpersonate(adminKey: string, modelUid: string): Promise<JsonAny> {
  const url = `${baseUrl()}/admin/impersonate`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminKey}`
    },
    body: JSON.stringify({ modelUid })
  });

  const body = await readBody(res);
  if (!res.ok) {
    const msg = typeof body === "string" ? body : JSON.stringify(body);
    throw new Error(msg || `HTTP ${res.status}`);
  }
  return body;
}

export async function workerMagicRedeem(token: string): Promise<JsonAny> {
  const url = `${baseUrl()}/chat/magic?token=${encodeURIComponent(token)}`;
  const res = await fetch(url, { method: "GET" });

  const body = await readBody(res);
  if (!res.ok) {
    const msg = typeof body === "string" ? body : JSON.stringify(body);
    throw new Error(msg || `HTTP ${res.status}`);
  }
  return body;
}

// Alias für bestehende MagicPage Importe
export async function fetchMagic(token: string): Promise<JsonAny> {
  return workerMagicRedeem(token);
}
